import Errors from './Errors';
import Loading from './Loading';


class Form {

  /**
   * Create a Form instance.
   * @param  {object} data Form data
   */
  constructor(data) {
    this.originalData = data;

    for (let field in data) {
      this[field] = data[field];
    }
    this.errors = new Errors();

  }


  /*
  * Fetch all relevant data for the form.
  */
  data() {
    let data = {};

    for (let property in this.originalData) {
      // if (this[property] != this.originalData[property])
      data[property] = this[property];
    }

    return data;
  }


  /*
   * Reset the form fields.
   */
  reset() {
    // for (let field in this.originalData) {
    //   this[field] = '';
    // }
    EventBus.$emit('loading-hide');
    this.errors.clear();
  }


  /*
   * Make a post request
   *
   * @param {string} url
   */
  post(url) {
    return this.submit('post', url);
  }


  /*
   * Make a get request
   *
   * @param {string} url
   */
  get(url) {
    return this.submit('get', url);
  }


  /*
   * Make a delete request
   *
   * @param {string} url
   */
  delete(url) {
    return this.submit('delete', url)
  }


  /*
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   */
  submit(requestType, url) {
    EventBus.$emit('loading-show');
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data())
          .then(response => {
            this.onSuccess(response.data);
            if (response.data.status == 'success' || typeof response.data.status === 'undefined') {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            this.onFail(error.response.data);

            reject({
              data: error.response.data,
              status: error.response.status
            });
          });
    });

  }

  /*
   * Handle a success form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    EventBus.$emit('loading-updateStatus', {status: data.status, message: data.message});
    this.reset();
  }

  /*
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
    EventBus.$emit('loading-updateStatus', {status: 'failed', message: 'Erro durante o processamento...'});
    EventBus.$emit('loading-hide');
  }

}

export default Form;
